/** @internal Development-only debug utility. Not used in production builds. */

// Only enable debug logs in development when explicitly needed
export const DEBUG_MODE = import.meta.env.DEV && false; // Change to true when debugging

import { logger } from '@/utils/logger';

export const debugLog = (...args: any[]) => {
  if (DEBUG_MODE) {
    logger.debug(...args);
  }
};
